import React from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownColumn,
  ContainerItem,
  ComingSoon,
  IconItem,
  EmptyIcon,
  ItemText,
  HeaderText,
} from '../../styles';

export const QuestionsColumn = ({ onNewQuestion, headerText, questions }) => (
  <DropdownColumn>
    <Dropdown.Header>
      <HeaderText>
        {headerText}
      </HeaderText>
    </Dropdown.Header>
    {questions.map((asset) => (
      <div>
        <Dropdown.Item onClick={() => !asset.comingSoon && onNewQuestion(asset.key)}>
          <ContainerItem>
            {
              asset.icon
                ? <IconItem src={asset.icon} />
                : <EmptyIcon />
            }
            <ItemText>{asset.label}</ItemText>
            {
              asset.comingSoon
              && <ComingSoon>Coming soon</ComingSoon>
            }
          </ContainerItem>
        </Dropdown.Item>
      </div>
    ))}
  </DropdownColumn>
);

QuestionsColumn.propTypes = {
  onNewQuestion: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    comingSoon: PropTypes.bool,
  })).isRequired,
  headerText: PropTypes.string.isRequired,
};

export default QuestionsColumn;
